export enum NoticeDataTypeEnum {
  Event = 'event',
  Email = 'email',
  Message = 'message',
  Todo = 'todo',
}
